import { render, staticRenderFns } from "./collector.vue?vue&type=template&id=0cf4893a&scoped=true"
import script from "./collector.vue?vue&type=script&lang=js"
export * from "./collector.vue?vue&type=script&lang=js"
import style0 from "./collector.vue?vue&type=style&index=0&id=0cf4893a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4893a",
  null
  
)

export default component.exports